<template>
  <div id="crew-labor-record" ref="crewLaborRecord">
    <div class="crew-labor-record-table h-full overflow-hidden">
      <vs-row
        id="crew-labor-record-header"
        vs-w="12"
        class="pt-4 gap-4"
        ref="crewLaborRecordHeader"
      >
        <!-- 基準労働期間 -->
        <div class="flex flex-start items-center">
          <standard-working-period
            ref="standardWorkPeriodList"
            :standardWorkPeriodList="standardWorkPeriodList"
            :selectedStandardWorkPeriod="selectedStandardWorkPeriod"
            :changeSelectedStandardWorkPeriod="changeSelectedStandardWorkPeriod"
          />
        </div>
        <!-- 年月 -->
        <div class="year-month-dropdown flex flex-start items-center">
          <select-month-field
            :yearMonthList="yearMonthList"
            :selectedYearMonth="selectedYearMonth"
            :changeSelectedYearMonth="changeSelectedYearMonth"
          />
        </div>
        <!-- ダウンロードボタン -->
        <div class="flex flex-start items-center">
          <button
            type="button"
            class="vs-button includeIcon download-btn"
            style=""
            :disabled="!isStandardWorkPeriodSelected || !isYearMonthSelected"
            @click.stop.prevent="() => openDownloadModal()"
          >
            <feather-icon
              icon="DownloadIcon"
              svgClasses="h-4 w-4"
              class="mr-2"
            />
            <span class="vs-button-text vs-button--text"> ダウンロード </span>
          </button>
        </div>
        <!-- 休日サマリ情報 -->
        <div class="flex items-center ml-auto">
          <holidays-table
            :numOfGrantedHoliays="numOfGrantedHoliays"
            :numOfRequiredHoliays="numOfRequiredHoliays"
            :numOfGrantedCompensationHoliays="numOfGrantedCompensationHoliays"
            :numOfRequiredCompensationHoliays="numOfRequiredCompensationHoliays"
            :numOfGrantedPaidHoliays="numOfGrantedPaidHoliays"
            :numOfRequiredPaidHoliays="numOfRequiredPaidHoliays"
          />
        </div>
      </vs-row>

      <!-- 作業グラフなどのテーブル -->
      <div
        id="rebor-record-table"
        class="flex flex-col overflow-x-auto"
        ref="crewReborRecordTable"
      >
        <div id="record-header" class="flex flex-shrink-0 sticky z-40">
          <div class="date flex items-end aisea-text-12-400-gray z-50">
            日付
          </div>
          <div
            class="
              working-graph
              flex flex-col
              justify-end
              items-start
              flex-shrink-0
              gap-2
              aisea-text-12-400-dark-gray
            "
          >
            <div>作業グラフ</div>
            <div class="timeline flex flex-shrink-0">
              <div
                v-for="(n, index) of cellNum"
                :key="`${n}-${index}`"
                class="timeline-cell text-center"
              >
                {{ index }}
              </div>
            </div>
          </div>
          <div class="aisea-text-12-400-gray register-holiday flex items-end">
            休日登録
          </div>
          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-day
              flex
              items-end
              justify-center
            "
          >
            1日当たりの労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              overtime-work
              flex
              items-end
              justify-center
            "
          >
            時間外労働
          </div>
          <div
            class="
              aisea-text-12-400-gray
              overtime-work
              flex
              items-end
              justify-center
            "
          >
            深夜残業
          </div>
          <div
            class="
              aisea-text-12-400-gray
              compensation-holiday-work
              flex
              items-end
              justify-center
            "
          >
            補償休日労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              safe-temporary-work
              flex
              items-end
              justify-center
            "
          >
            安全臨時労働時間数
          </div>
          <div
            v-for="(task, index) of taskKindList"
            :key="`${task.id}-${index}`"
            class="
              aisea-text-12-400-gray
              safe-temporary-work
              flex
              items-end
              justify-center
            "
          >
            {{ task.label }}
          </div>

          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去5日間以内の労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去7日間以内の労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去28日間の時間外労働
          </div>
          <div
            class="
              aisea-text-12-400-gray
              number-of-breaks
              flex
              items-end
              justify-center
            "
          >
            休息時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              the-longer-number-of-hours-when-splitting
              flex
              items-end
              justify-center
            "
          >
            分割時の長い方の休息時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              one-week-when-compensation-holidays-occur
              flex
              items-end
              justify-center
            "
          >
            補償休日が生じる1週間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              number-of-hours-exceeded
              flex
              items-end
              justify-center
            "
          >
            補償休日超過時間数
          </div>
        </div>
        <!-- 行のデータ -->
        <div id="record-body" class="flex flex-col flex-shrink-0">
          <crew-labor-record-row
            v-for="(dataRecord, index) in rowDataWithTotal"
            :key="index"
            :momentObj="dataRecord.momentObj"
            :date="dataRecord.date"
            :dateStr="dataRecord.dateStr"
            :cellSize="cellSize"
            :cellNum="cellNum"
            :maxOfDividedRestTime="dataRecord.maxOfDividedRestTime"
            :restTime="dataRecord.restTime"
            :dailyOvertime="dataRecord.dailyOvertime"
            :lateNightOvertime="dataRecord.lateNightOvertime"
            :dailyWorkingTime="dataRecord.dailyWorkingTime"
            :compensatoryOffWorkingTime="dataRecord.compensatoryOffWorkingTime"
            :sevenDaysWorkingTime="dataRecord.sevenDaysWorkingTime"
            :compensatoryOffWeek="dataRecord.compensatoryOffWeek"
            :compensatoryOffOvertime="dataRecord.compensatoryOffOvertime"
            :safeTemporaryWorkingTime="dataRecord.safeTemporaryWorkingTime"
            :timesheetList="dataRecord.timesheetList"
            :warningHours="dataRecord.warningHours"
            :criticalHours="dataRecord.criticalHours"
            :dayOff="dataRecord.dayOff"
            :dayOffId="dataRecord.dayOffId"
            :taskTimes="dataRecord.taskTimes"
            :fiveDaysWorkingTime="dataRecord.fiveDaysWorkingTime"
            :twentyEightDaysOvertime="dataRecord.twentyEightDaysOvertime"
            :enterpriseCrewId="enterpriseCrewId"
            :searchEnterpriseCrewDayOffDay="
              async () =>
                searchEnterpriseCrewDayOffDay(
                  enterpriseCrewId,
                  laborId,
                  selectedMoment.format('YYYYMM')
                )
            "
            :fetchHolidaySummary="
              async () =>
                fetchHolidaySummary(
                  enterpriseCrewId,
                  laborId,
                  selectedMoment.format('YYYYMM')
                )
            "
            :startOfWorkPeriod="startOfWorkPeriod"
            :endOfWorkPeriod="endOfWorkPeriod"
            :isTotalRow="dataRecord.isTotalRow"
            :isFiveDaysWorkingTimeWarning="dataRecord.isFiveDaysWorkingTimeWarning"
            :isSevenDaysWorkingTimeAlert="dataRecord.isSevenDaysWorkingTimeAlert"
            :isSevenDaysWorkingTimeWarning="dataRecord.isSevenDaysWorkingTimeWarning"
            :isTwentyEightDaysOvertimeAlert="dataRecord.isTwentyEightDaysOvertimeAlert"
            :isMaxOfDividedRestTimeAlert="dataRecord.isMaxOfDividedRestTimeAlert"
          />
        </div>
      </div>
    </div>
    <vs-prompt
      class="crew-labor-record-download-dialog"
      :color="AISEA_COLOR.BLUE"
      @close="closeDownloadDialog"
      :active.sync="showDownloadDialog"
      title="労務管理記録簿 期間指定"
      accept-text="ダウンロード"
      cancel-text="キャンセル"
      :is-valid="true"
      buttons-hidden
    >
      <div class="mb-5">ダウンロードする期間を指定してください。</div>
      <div class="flex mb-5">
        <div class="mr-5">
          <label>開始日</label>
          <date-picker
            :value.sync="downloadStartDate"
            placeholder="2022/01/01"
            dateFormat="Y/m/d"
          ></date-picker>
        </div>
        <div class="items-center" style="margin-top: 28px;">〜</div>
        <div class="ml-5">
          <label>終了日</label>
          <date-picker
            :value.sync="downloadEndDate"
            placeholder="2022/01/30"
            dateFormat="Y/m/d"
          ></date-picker>
        </div>
      </div>
      <span class="validation-label">{{
        getDownloadDialogValidationMessage
      }}</span>
      <div class="flex w-full justify-end items-center">
        <div class="m-3 mb-0">
          <vs-button
            type="border"
            style="width: 6rem; padding: 0.4rem"
            @click="closeDownloadDialog"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div class="m-3 mb-0">
          <vs-button
            :color="AISEA_COLOR.BLUE"
            :disabled="!isDownloadDialogValid"
            style="width: 8rem; padding: 0.4rem"
            @click="
              handleClickDownload(
                enterpriseCrewId,
                downloadStartDate,
                downloadEndDate
              )
            "
            >ダウンロード</vs-button
          >
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moment from "moment-timezone";
import _ from "lodash";
import CrewLaborRecordRow from "./components/CrewLaborRecordRow";
import SelectMonthField from "./components/SelectMonthField";
import StandardWorkingPeriod from "../standard-working-period/StandardWorkingPeriod";
import HolidaysTable from "./components/HolidaysTable.vue";
import DatePicker from "../components/DatePicker.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} = createNamespacedHelpers("crewLabor");
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewRecordBookApi = AiseaApiFactory.get(
  "enterpriseCrewRecordBook"
);
const enterpriseCrewDayOffDayApi = AiseaApiFactory.get(
  "enterpriseCrewDayOffDay"
);
const enterpriseTimesheetTaskApi = AiseaApiFactory.get(
  "enterpriseTimesheetTask"
);
import FileSaver from "file-saver";
const WEEKDAYS = [
  "日曜日",
  "月曜日",
  "火曜日",
  "水曜日",
  "木曜日",
  "金曜日",
  "土曜日",
];
const WEEKDAYS_SHORT = ["日", "月", "火", "水", "木", "金", "土"];

export default {
  name: "CrewLaborRecord",
  components: {
    CrewLaborRecordRow,
    SelectMonthField,
    StandardWorkingPeriod,
    HolidaysTable,
    DatePicker,
  },
  props: {
    enterpriseCrewId: { type: String, require: true },
    active: { type: Boolean, default: false },
    cellSize: { type: Number, default: 30 },
    cellNum: { type: Number, default: 24 },
    activeTab: { type: Number },
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      ...this.getInitialState(),
    };
  },
  watch: {
    enterpriseCrewId() {
      if (!this.active) return;
      this.setUp();
    },
    async active() {
      if (!this.active) return;
      this.setUp();
      this.$nextTick(() => {
        this.setLeborReocrdHeaderHeight();
      });
    },
  },
  computed: {
    ...mapGetters(["enterpriseCrewLaborId"]),
    ...mapState(["labors"]),
    isDownloadDialogValid() {
      return !this.getDownloadDialogValidationMessage;
    },
    getDownloadDialogValidationMessage() {
      if (!this.downloadStartDate || !this.downloadEndDate) {
        return "入力されていない項目があります";
      }
      if (
        moment(this.downloadStartDate).isAfter(moment(this.downloadEndDate))
      ) {
        return "開始日が終了日よりも後になるように指定してください";
      }
      if (
        moment(this.downloadEndDate).diff(
          moment(this.downloadStartDate),
          "days"
        ) >= 31
      ) {
        return "開始日と終了日の幅は31日間を超えないように指定してください";
      }
      return null;
    },
    rowData() {
      return this.getRowData(this.recordBooks, this.dayOffDays);
    },
    rowDataWithTotal() {
      if (this.totalRow != null) {
        return [...this.rowData, this.totalRow];
      } else {
        return this.rowData;
      }
    },

    daysOfselectedMonth() {
      if (!this.selectedMoment) return [];
      return this.getSelectedDays(this.selectedMoment.daysInMonth());
    },
    standardWorkPeriodList: {
      get() {
        return this.labors;
      },
      set(val) {
        this.SET_LABORS(val);
      },
    },
    laborId() {
      return this.selectedStandardWorkPeriod.id;
    },
    yearMonthList() {
      const {
        work_period_from: wpf,
        work_period_to: wpt,
      } = this.selectedStandardWorkPeriod;
      if (!wpf || !wpt) return [];
      const from = moment(wpf);
      const to = moment(wpt);
      const LIMIT_OF_LENGTH = 13;

      return _.range(LIMIT_OF_LENGTH)
        .map((_n, i) => {
          if (i > 0) from.add(1, "month");
          if (from.startOf("month").isAfter(to)) return;
          const yearMonth = from.format("YYYY/MM");
          return {
            id: yearMonth,
            label: yearMonth,
            year: from.year(),
            month: from.month(),
          };
        })
        .filter(yM => yM);
    },
    selectedMoment() {
      if (!(this.selectedYear > 0) || !(this.selectedMonth >= 0)) return null;
      return moment({ years: this.selectedYear, months: this.selectedMonth });
    },
    selectedYear() {
      if (this.selectedYearMonth && this.selectedYearMonth.year > 0)
        return this.selectedYearMonth.year;
      return null;
    },
    selectedMonth() {
      if (this.selectedYearMonth && this.selectedYearMonth.month > 0)
        return this.selectedYearMonth.month;
      return null;
    },
    startOfWorkPeriod() {
      if (!this.selectedStandardWorkPeriod) return null;
      return moment(this.selectedStandardWorkPeriod.work_period_from);
    },
    endOfWorkPeriod() {
      if (!this.selectedStandardWorkPeriod) return null;
      return moment(this.selectedStandardWorkPeriod.work_period_to);
    },
    numOfGrantedHoliays() {
      return this.holidaySummary.day_off;
    },
    numOfRequiredHoliays() {
      return this.holidaySummary.mandatory_day_off;
    },
    numOfGrantedCompensationHoliays() {
      return this.holidaySummary.compensatory_off;
    },
    numOfRequiredCompensationHoliays() {
      return this.holidaySummary.mandatory_conpensatory_off;
    },
    numOfGrantedPaidHoliays() {
      return this.holidaySummary.paid_off;
    },
    numOfRequiredPaidHoliays() {
      return this.holidaySummary.mandatory_paid_off;
    },
    isStandardWorkPeriodSelected() {
      return Object.keys(this.selectedStandardWorkPeriod).length > 0;
    },
    isYearMonthSelected() {
      return this.selectedYearMonth !== null;
    },
  },
  methods: {
    ...mapActions(["fetchLaborPeriodList"]),
    ...mapMutations(["SET_ENTERPRISE_CREW_ID", "SET_LABORS"]),
    async changeSelectedStandardWorkPeriod(nextWorkingPeriod) {
      this.selectedStandardWorkPeriod = nextWorkingPeriod;
      const initialSelectedYearMonth = await this.getInitialSelectedYearMonth();
      this.changeSelectedYearMonth(initialSelectedYearMonth);
    },
    async changeSelectedYearMonth(nextYearMonth) {
      this.selectedYearMonth = nextYearMonth;

      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      this.fetchRecordBooks(this.enterpriseCrewId, {
        params: {
          enterprise_crew_labor_id: this.laborId,
          yyyymm: this.selectedMoment.format("YYYYMM"),
        },
      });
      this.searchEnterpriseCrewDayOffDay(
        this.enterpriseCrewId,
        this.laborId,
        this.selectedMoment.format("YYYYMM")
      );
      this.fetchHolidaySummary(
        this.enterpriseCrewId,
        this.laborId,
        this.selectedMoment.format("YYYYMM")
      );
    },
    async fetchRecordBooks(enterpriseCrewId, payload) {
      return enterpriseCrewRecordBookApi
        .recordBooks(enterpriseCrewId, payload)
        .then(res => {
          if (res.status !== true) throw new Error();
          if (!res.data.inline_response_enterprise_crew_record_books)
            throw new Error();
          this.recordBooks =
            res.data.inline_response_enterprise_crew_record_books;

          this.totalRow = {
            compensatoryOffOvertime: res.data.total_compensatory_off_overtime,
            compensatoryOffWorkingTime:
              res.data.total_compensatory_off_working_time,
            dailyOvertime: res.data.total_daily_overtime,
            dailyWorkingTime: res.data.total_daily_working_time,
            lateNightOvertime: res.data.total_late_night_overtime,
            safeTemporaryWorkingTime:
              res.data.total_safe_temporary_working_time,
            taskTimes: this.taskKindList.map(element => {
              const targetTask = res.data.total_task_times.find(
                task => task.id === element.id
              );
              return {
                id: element.id,
                minutes: targetTask["minutes"] || 0,
              };
            }),

            isTotalRow: true,
          };
        })
        .catch(err => {
          console.log(err);
          this.$vs.notify({
            title: "勤怠情報の取得に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async fetchHolidaySummary(enterpriseCrewId, laborId, yyyymm) {
      return enterpriseCrewDayOffDayApi
        .book(enterpriseCrewId, {
          enterprise_crew_labor_id: laborId,
          yyyymm,
        })
        .then(res => {
          if (res.status !== true) throw new Error();
          if (!res.data) throw new Error();
          this.holidaySummary = res.data;
        })
        .catch(err => {
          console.log(err);
          this.$vs.notify({
            title: "休暇概要情報の取得に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async setUp() {
      if (!this.active) return;
      this.holidaySummary = this.getInitialState().holidaySummary;
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
        await this.initWorkPeriodList();
      } catch (err) {
        console.log(err);
        this.$vs.notify({
          title: "基準労働期間の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } finally {
        this.$vs.loading.close();
      }
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
        await this.fetchTasks();
      } catch (err) {
        console.log(err);
        this.$vs.notify({
          title: "作業種別の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } finally {
        this.$vs.loading.close();
      }
      if (!this.isStandardWorkPeriodSelected) return;
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      moment(this.selectedYearMonth).isSameOrBefore(
        moment().startOf("month")
      ) &&
        this.fetchRecordBooks(this.enterpriseCrewId, {
          params: {
            enterprise_crew_labor_id: this.laborId,
            yyyymm: this.selectedMoment.format("YYYYMM"),
          },
        });
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      this.searchEnterpriseCrewDayOffDay(
        this.enterpriseCrewId,
        this.laborId,
        this.selectedMoment.format("YYYYMM")
      );
      this.fetchHolidaySummary(
        this.enterpriseCrewId,
        this.laborId,
        this.selectedMoment.format("YYYYMM")
      );
    },
    tearDown() {},
    // テーブルの高さを決めるために、ヘッダ部分の高さを取得する
    setLeborReocrdHeaderHeight() {
      const crewLaborRecordHeader = this.$refs.crewLaborRecordHeader;
      this.$refs.crewLaborRecord.style.setProperty(
        "--crew-labor-record-header-height",
        `${crewLaborRecordHeader.$el.getBoundingClientRect().height}px`
      );
    },
    getDateStr(momentObj) {
      return momentObj.format("M/D (ddd)");
    },
    // 行を作成するのに使用する
    getSelectedDays(num) {
      return Array.from({ length: num }, (_value, index) => index + 1);
    },
    async fetchTasks() {
      try {
        const res = await enterpriseTimesheetTaskApi.search({});
        this.taskKindList = res.data.list
          .map(task => {
            return {
              id: task.id,
              // カスタム作業種別の場合はlabelをそのまま表示名として採用
              // デフォルト作業種別の場合はlabelをlocalizedKeyとして用いて表示名を取得
              label: task.is_custom
                ? task.label
                : this.$t(`Views.Crew.LaborRecord.Tasks.${task.label}`),
              localized_key: task.localized_key,
              is_alert_target: task.is_alert_target,
              show_on_record_book: task.show_on_record_book,
              sort_order: task.sort_order,
              used_by_record_book: task.used_by_record_book,
            };
          })
          .filter(task => task.show_on_record_book);
      } catch (e) {
        throw Error(e);
      }
    },
    getRowData(recordBooks, dayOffDays) {
      const momentObj = moment(this.selectedMoment).startOf("month");
      momentObj.locale("ja", {
        weekdays: WEEKDAYS,
        weekdaysShort: WEEKDAYS_SHORT,
      });
      const rowList = this.daysOfselectedMonth.map((day, i) => {
        if (i > 0) momentObj.add(1, "day");
        const dateFormateRecordBook = momentObj.format("YYYYMMDD");
        const recordBook =
          recordBooks.find(rb => rb.date === dateFormateRecordBook) || {};
        const dateFormateDayOffDay = momentObj.format("YYYY-MM-DD");
        const dayOffDay =
          dayOffDays.find(dod => dod.date === dateFormateDayOffDay) || {};

        let taskTimes = this.taskKindList.map(task => {
          if (recordBook.task_times) {
            const taskTime = recordBook.task_times.find(
              taskTime => taskTime.id === task.id
            );
            return {
              id: task.id,
              minutes: taskTime ? taskTime.minutes : 0,
              color_hex: task.color_hex,
              label: task.label,
            };
          } else {
            return {
              id: task.id,
              minutes: 0,
              color_hex: task.color_hex,
              label: task.label,
            };
          }
        });

        return {
          year: this.selectedYear,
          dateStr: this.getDateStr(momentObj),
          momentObj: moment(momentObj),
          month: this.selectedMonth,
          day,
          date: recordBook.date || dateFormateRecordBook,
          currentDayStr: dateFormateDayOffDay,
          // 作業グラフ上の打刻に使用
          timesheetList: [...(recordBook.timesheet_list || [])],
          warningHours: [...(recordBook.warning_hours || [])],
          criticalHours: [...(recordBook.critical_hours || [])],
          dailyWorkingTime: recordBook.daily_working_time, // 1日当たりの労働時間
          dailyOvertime: recordBook.daily_overtime, // 時間外労働
          lateNightOvertime: recordBook.late_night_overtime, // 深夜労働
          compensatoryOffWorkingTime: recordBook.compensatory_off_working_time, // 補償休日労働時間
          sevenDaysWorkingTime: recordBook["7days_working_time"], // 過去7日間以内の労働時間
          compensatoryOffWeek: recordBook.compensatory_off_week, // 補償休日が生じる1週間: 0/1
          compensatoryOffOvertime: recordBook.compensatory_off_overtime, // 補償休日超過時間数
          safeTemporaryWorkingTime: recordBook.safe_temporary_working_time, // 安全臨時労働時間数
          taskTimes: taskTimes, // 作業種別
          fiveDaysWorkingTime: recordBook["5days_working_time"], // 過去5日間以内の労働時間
          twentyEightDaysOvertime: recordBook["28days_overtime"], // 過去28日間以内の時間外労働
          restTime: recordBook.rest_time, // 休息時間
          maxOfDividedRestTime: recordBook.max_of_divided_rest_time, // 分割時の長い方の休息時間
          dayOff: dayOffDay.type,
          dayOffId: dayOffDay.id,
          isFiveDaysWorkingTimeWarning: recordBook.is_hour_of_work5d_warning,
          isSevenDaysWorkingTimeAlert: recordBook.is_hour_of_work1w_critical,
          isSevenDaysWorkingTimeWarning: recordBook.is_hour_of_work1w_warning,
          isTwentyEightDaysOvertimeAlert: recordBook.is_hour_of_overtime_work28d_critical,
          isMaxOfDividedRestTimeAlert: recordBook.is_hour_of_rest24h_critical,
        };
      });

      return rowList;
    },
    openDownloadModal() {
      this.downloadStartDate = moment(this.selectedYearMonth).toDate();
      this.downloadEndDate = moment(this.selectedYearMonth)
        .add(1, "month")
        .add(-1, "day")
        .toDate();
      this.showDownloadDialog = true;
    },
    closeDownloadDialog() {
      this.showDownloadDialog = false;
    },
    async handleClickDownload(enterpriseCrewId, startAt, endAt) {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      const startAtString = moment(startAt).format("YYYY-MM-DD");
      const endAtString = moment(endAt).format("YYYY-MM-DD");
      try {
        const res = await enterpriseCrewRecordBookApi.exportByDateRange(
          enterpriseCrewId,
          {
            params: {
              enterprise_crew_labor_id: this.selectedStandardWorkPeriod.id,
              start_at: startAtString,
              end_at: endAtString,
            },
          }
        );
        if (res.status !== true) throw new Error();
        const fileName = `労務管理記録簿_${startAtString}_${endAtString}.xlsx`;
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async searchCrewLabors() {
      await this.fetchLaborPeriodList();
    },
    async getInitialSelectedYearMonth() {
      const currentMoment = moment();
      const sameOrBeforeYearMonthList = this.yearMonthList.filter(
        ({ year, month }) =>
          moment({ years: year, months: month }).isSameOrBefore(currentMoment)
      );

      const currentMomentYearMonth = currentMoment.format("YYYYMM");
      const currentYearMonth = this.yearMonthList.find(({ year, month }) => {
        return (
          moment({ years: year, months: month }).format("YYYYMM") ===
          currentMomentYearMonth
        );
      });

      if (currentYearMonth) return currentYearMonth;

      if (sameOrBeforeYearMonthList.length > 0)
        return sameOrBeforeYearMonthList[0];
      if (this.yearMonthList.length > 0) return this.yearMonthList[0];
      return {};
    },
    async searchEnterpriseCrewDayOffDay(enterpriseCrewId, laborId, yyyymm) {
      return enterpriseCrewDayOffDayApi
        .search(enterpriseCrewId, {
          enterprise_crew_labor_id: laborId,
          yyyymm,
        })
        .then(res => {
          if (res.status !== true) throw new Error();
          if (!res.data.enterprise_crew_day_off_days) throw new Error();
          this.dayOffDays = res.data.enterprise_crew_day_off_days;
        })
        .catch(err => {
          console.log(err);
          this.$vs.notify({
            title: "休暇情報の取得に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async initWorkPeriodList() {
      this.SET_ENTERPRISE_CREW_ID(this.enterpriseCrewId);
      if (!this.$refs.standardWorkPeriodList) {
        await this.fetchLaborPeriodList();
      } else {
        await this.$refs.standardWorkPeriodList.initWorkingPeriodList();
      }
      this.selectedYearMonth = await this.getInitialSelectedYearMonth();
    },
    getInitialState() {
      return {
        selectedYearMonth: null,
        recordBooks: [],
        selectedStandardWorkPeriod: {},
        dayOffDays: [],
        holidaySummary: {},
        taskKindList: [],
        showDownloadDialog: false,
        downloadStartDate: null,
        downloadEndDate: null,
        totalRow: null,
      };
    },
  },
  beforeCreate() {},
  async created() {
    this.setUp();
  },
  beforeMount() {},
  async mounted() {
    this.$nextTick(() => {
      this.initWorkPeriodList();
      this.setLeborReocrdHeaderHeight();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {
    this.tearDown();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#crew-labor-record {
  --vs-primary: 3, 155, 229;
  --crew-labor-record-header-height: 87px;
  --crew-labor-record-table-height: calc(
    100% - var(--crew-labor-record-header-height)
  );
  height: 100%;
  .vx-card {
    padding: 20px;
  }
  #crew-labor-record-header {
    min-height: 87px;
    height: var(--crew-labor-record-header-height);
    .download-btn {
      border: 1px solid rgb(var(--vs-primary));
      background: transparent;
      color: rgb(var(--vs-primary));
      height: 2.7rem;
    }
  }
  #rebor-record-table {
    height: var(--crew-labor-record-table-height);
    #record-header {
      width: fit-content;
      top: 0;
      left: 0;
      height: 50px;
      border-bottom: 1px solid $aisea-light-gray;
      background-color: $aisea-pure-white;
      > div {
        position: sticky;
        top: 0;
        flex-shrink: 0;
        height: 49px;
        border-radius: 0px;
        padding: 0px, 20px, 0px, 10px;
        &:first-child {
          position: sticky;
          top: 0;
          left: 0;
        }
      }
      > div:not(.working-graph) {
        min-width: 80px;
        width: 80px;
        padding: 2px;
        padding-bottom: 10px;

        &.register-holiday {
          width: 180px;
          padding: 10px;
        }
        &.working-hours-per-day {
          padding: 9px;
        }
        &.overtime-work {
          padding-bottom: 10px;
        }
        &.compensation-holiday-work {
          padding: 10px;
        }
        &.safe-temporary-work {
          padding: 8px;
        }
        &.date {
          min-width: 85px;
          padding: 4px 10px;
          background-color: $aisea-pure-white;
        }
      }
      .the-longer-number-of-hours-when-splitting {
        height: 49px;
        width: 80px;
        border-radius: 0px;
        padding: 0px, 20px, 0px, 10px;
      }
      .timeline-cell {
        height: 20px;
        min-width: 30px;
        border-left: solid 1px #e0e0e0;
        &:last-child {
          border-right: solid 1px #e0e0e0;
        }
      }
    }
    #record-body {
      width: fit-content;
    }
  }
}

.crew-labor-record-download-dialog {
  label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }
  .validation-label {
    color: red;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
</style>
